import React, { Component } from "react";
import { 
    Button,
    Intent,
    Card, 
    Checkbox,
    FormGroup,
    InputGroup,
    Callout } from "@blueprintjs/core";
import { Trans } from "react-i18next";
import DeviceIdTable from "./DeviceIdTable"
import { EacAuthenticatedGetFetch, EacAuthenticatedPutFetch } from "../../utils/ExternalAccessControlAuthenticatedFetch";



export default class BeMobilePage extends Component {
    constructor() {
        super();
        this.state = {
            baseUrl: "",
            external_reference: "",
            country_code: "",
            location: "",
            apiKey: "",
            profileId: 0,
            priceCalculateLocaly : true
        };        
    }

    componentDidMount() {
        EacAuthenticatedGetFetch('/bemobile/config', (data)=>{
            const ret = {baseUrl: "", external_reference: "", country_code: "", location: "", apiKey: "", profileId: 0, priceCalculateLocaly: true}
            if(data.baseUrl)
                ret.baseUrl = data.baseUrl;
            if(data.external_reference)
                ret.external_reference = data.external_reference;
            if(data.country_code)
                ret.country_code = data.country_code;
            if(data.location)
                ret.location = data.location;
            if(data.apiKey)
                ret.apiKey = data.apiKey;
            if(data.profileId)
                ret.profileId = data.profileId;
            if(data.priceCalculateLocaly)
                ret.priceCalculateLocaly = data.priceCalculateLocaly;
            this.setState(ret);
        });       
    }
    disableSaveButton(){
        return !(this.state.baseUrl.length > 0 
            &&  this.state.external_reference.length > 0
            &&  this.state.country_code.length > 0
            &&  this.state.location.length > 0
            &&  this.state.apiKey.length > 0
            &&  this.state.profileId > 0);
    }
    saveConfig() {
        EacAuthenticatedPutFetch('/bemobile/config', this.state, (data)=>{

        });
    }


    render() {
        return (
          <div>
            <Callout  title={<Trans>Configuration</Trans>}>
              <Card>
                  <form>
                    <FormGroup label={<Trans>external bo url</Trans>} labelFor="ex-bo-url-input">
                      <InputGroup id="ex-bo-url-input"
                        onChange={(ti) => { this.setState({ baseUrl: ti.target.value }); }}
                        value={this.state.baseUrl}
                        intent="normal"
                        type="text"
                      />
                    </FormGroup>
                    <FormGroup label={<Trans>api Key</Trans>} labelFor="apiKey-input">
                      <InputGroup
                        id="apiKey-input"
                        type="text"
                        onChange={(ti) => { this.setState({ apiKey: ti.target.value }); }}
                        value={this.state.apiKey}
                        intent="normal"
                      />
                      </FormGroup>
                    <FormGroup label={<Trans>external reference</Trans>} labelFor="external_reference-input">
                      <InputGroup
                        id="external_reference-input"
                        type="text"
                        onChange={(ti) => { this.setState({ external_reference: ti.target.value }); }}
                        value={this.state.external_reference}
                        intent="normal"
                      />
                    </FormGroup>
                    <FormGroup label={<Trans>country code</Trans>} labelFor="country_code-input">
                      <InputGroup
                        id="country_code-input"
                        type="text"
                        onChange={(ti) => { this.setState({ country_code: ti.target.value }); }}
                        value={this.state.country_code}
                        intent="normal"
                      />
                    </FormGroup>
                    <FormGroup label={<Trans>location</Trans>} labelFor="location-input">
                      <InputGroup
                        id="location-input"
                        type="text"
                        onChange={(ti) => { this.setState({ location: ti.target.value }); }}
                        value={this.state.location}
                        intent="normal"
                      />
                    </FormGroup>
                    <FormGroup label={<Trans>profile</Trans>} labelFor="profile-input">
                      <InputGroup
                        id="profile-input"
                        type="number"
                        onChange={(ti) => { this.setState({ profileId: ti.target.value }); }}
                        value={this.state.profileId}
                        intent="normal"
                      />
                    </FormGroup>
                    <FormGroup label={<Trans>priceCalculateLocaly</Trans>} labelFor="priceCalculateLocaly-input">
                        <Checkbox id="priceCalculateLocaly-input"
                            onChange={(ti) => this.setState({ priceCalculateLocaly: ti.target.checked })}
                            checked={this.state.priceCalculateLocaly}
                            large={true}
                        />
                    </FormGroup>
                  </form>
                  <div className="flexbox-right">
                    <Button
                        text={<Trans>edit</Trans>}
                        icon="send-to"
                        intent={Intent.WARNING}
                        type="submit"
                        disabled={this.disableSaveButton()}
                        onClick={() => { this.saveConfig()}}
                        />
                  </div>
              </Card>
            </Callout>
            <Callout  title={<Trans>settings</Trans>}>
                  <DeviceIdTable target="bemobile"></DeviceIdTable>
            </Callout>
          </div>
        );
    }
}
